const dt = (iso) => (iso ? new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" }) : "—");
const qty = (q) => (q === null || q === undefined ? "—" : Number(q).toLocaleString("pt-PT", { maximumFractionDigits: 3 }));

export const CashReportStockMovements = ({ report }) => {
  const rows = [
    ...(report?.categories || []).flatMap((c) => c.items.flatMap((it) => it.movements.map((m) => ({ ...m, product_name: it.product_name, sold: true })))),
    ...(report?.other_stock_movements || []).flatMap((o) => o.movements.map((m) => ({ ...m, product_name: o.product_name, sold: false }))),
  ].sort((a, b) => (a.created_at || "").localeCompare(b.created_at || ""));
  return (
    <div className="rounded-lg border overflow-x-auto max-h-80 overflow-y-auto" data-testid="cash-report-stock-moves">
      <table className="w-full text-xs">
        <thead className="bg-muted/70 sticky top-0 text-[11px] uppercase tracking-wide text-muted-foreground">
          <tr><th className="text-left p-2">Hora</th><th className="text-left p-2">Produto</th><th className="text-left p-2">Movimento</th><th className="text-right p-2">Qtd</th><th className="text-right p-2">Antes</th><th className="text-right p-2">Depois</th><th className="text-left p-2">Por</th></tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={7} className="p-4 text-center text-muted-foreground">Sem movimentos de stock neste período</td></tr>}
          {rows.map((m, i) => (
            <tr key={i} className="border-t">
              <td className="p-2 font-mono whitespace-nowrap">{dt(m.created_at)}</td>
              <td className="p-2 font-medium">{m.product_name}{!m.sold && <span className="ml-1 text-[10px] text-muted-foreground">(não vendido)</span>}</td>
              <td className="p-2 text-muted-foreground">{m.reason || (m.type === "in" ? "Entrada" : "Saída")}</td>
              <td className={`p-2 text-right font-mono font-semibold ${m.type === "in" ? "text-emerald-600" : "text-red-600"}`}>{m.type === "in" ? "+" : "−"}{qty(m.quantity)}</td>
              <td className="p-2 text-right font-mono">{qty(m.stock_before)}</td>
              <td className="p-2 text-right font-mono">{qty(m.stock_after)}</td>
              <td className="p-2 text-muted-foreground">{m.by}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
